import { firebase_auth } from "@src/utility_functions/database_operations/config/firebaseConfig";
import {
  formatUserDocumentPublic,
  formatUserDocumentPrivate,
} from "#shared/formatDocument/formatUserDocument";
import { mergeTwoObjects } from "#root/shared/utility_functions/object_functions.js";
import { fetchFirestoreUserObjectPublic } from "@src/utility_functions/database_operations/users/readUser/fetchFirestoreUserObjectPublic";
import { fetchFirestoreUserObjectPrivate } from "@src/utility_functions/database_operations/users/readUser/fetchFirestoreUserObjectPrivate";

export const fetchFirestoreUserObject = async (firestoreID) => {
  let returnValue;
  try {
    const userDocumentPublic =
      await fetchFirestoreUserObjectPublic(firestoreID);
    const userDocumentPublicFormatted =
      formatUserDocumentPublic(userDocumentPublic);
    if (firebase_auth.currentUser?.uid === firestoreID) {
      const userDocumentPrivate =
        await fetchFirestoreUserObjectPrivate(firestoreID);
      const userDocumentPrivateFormatted =
        formatUserDocumentPrivate(userDocumentPrivate);
      returnValue = mergeTwoObjects(
        userDocumentPublicFormatted,
        userDocumentPrivateFormatted,
        ["profilePicture"],
      );
    } else {
      returnValue = userDocumentPublicFormatted;
    }
  } catch (error) {
    console.warn(error);
    returnValue = undefined;
  }
  return returnValue;
};
